<section class="ups" [class.ups--bare]="bare">

  @if (!bare) {
    <header class="ups__head">
      <h3 class="ups__title">
        <i class="fa-solid fa-arrow-trend-up"></i>
        {{ 'CALENDAR.UPCOMING' | translate }}
      </h3>
      <a class="ups__all" [routerLink]="calendarLink">
        {{ 'DASHBOARD.VIEW_ALL' | translate }}
        <i class="fa-solid fa-arrow-right"></i>
      </a>
    </header>
  } @else {
    <h4 class="ups__title ups__title--sm">
      <i class="fa-solid fa-arrow-trend-up"></i>
      {{ 'CALENDAR.UPCOMING' | translate }}
    </h4>
  }

  @if (loading) {
    <p class="ups__hint">{{ 'LOADINGS.LOADING' | translate }}</p>
  } @else if (upcoming().length === 0) {
    <p class="ups__hint">{{ 'CALENDAR.UPCOMING_EMPTY' | translate }}</p>
  } @else {
    <ul class="ups__list">
      @for (s of upcoming(); track s.id) {
        <li>
          <div class="ups-item" [class]="view.colorClass(s)" [class.is-live]="isLive(s)">
            <span class="ups-item__date">
              @if (isToday(s)) {
                <span class="ups-item__day">{{ time(s.startTime) }}</span>
                <span class="ups-item__month">{{ 'CALENDAR.TODAY' | translate }}</span>
              } @else {
                <span class="ups-item__day">{{ start(s) | date:'dd' }}</span>
                <span class="ups-item__month">{{ start(s) | localizedDate:'MMM' }}</span>
              }
            </span>

            <span class="ups-item__body">
              <span class="ups-item__title">
                {{ s.title }}
                @if (isLive(s)) {
                  <span class="ups-item__live">
                    <span class="ups-item__pulse"></span>
                    {{ 'CALENDAR.LIVE_NOW' | translate }}
                  </span>
                }
              </span>
              <span class="ups-item__meta">
                <i [class]="view.kindIcon(s.sessionKind)"></i>
                {{ time(s.startTime) }}–{{ time(s.endTime) }}
                @if (view.subjectLabel(s)) { · {{ view.subjectLabel(s) }} }
                @if (s.groupName) { · {{ s.groupName }} }
              </span>
            </span>

            @if (s.meetingUrl && isLive(s)) {
              <!-- Passe par l'API : l'accès est journalisé avant d'ouvrir la réunion -->
              <button type="button" class="ups-item__join" (click)="join(s)">
                <i class="fa-solid fa-video"></i>
                {{ 'CALENDAR.JOIN' | translate }}
              </button>
            }
          </div>
        </li>
      }
    </ul>
  }
</section>
